import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  inject,
  input,
} from '@angular/core';

import { UiStore } from '@pt/services';

// TODO: Using this component refactor scroll shadows on every page
@Component({
  selector: 'pt-scroll-shadow',
  template: '',
  styleUrls: ['./scroll-shadow.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScrollShadowComponent {
  readonly #uiStore = inject(UiStore);

  alwaysVisible = input(false, { transform: booleanAttribute });

  @HostBinding('class.pt-scroll-shadow_visible') get visibleShadowClass() {
    return this.#uiStore.isHeaderShadowVisible() || this.alwaysVisible;
  }
}
